import {Component, OnInit} from '@angular/core';
import moment from "moment";
import {Router} from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    private readonly router: Router
  ) {
    moment.locale('pl-PL');
  }

  ngOnInit(): void {
    const target = sessionStorage.getItem('postLoginRedirect');
    if (target) {
      sessionStorage.removeItem('postLoginRedirect');
      this.router.navigateByUrl(target);
    }
  }
}
